export enum BUSINESS_ACCOUNT_REQUEST_STATUS_ENUM {
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
}

export enum BUSINESS_SECTOR_ENUM {
  TRANSPORT_AND_LOGISTICS = 'TRANSPORT_AND_LOGISTICS',
  CONSTRUCTION = 'CONSTRUCTION',
  AGRICULTURE = 'AGRICULTURE',
  MANUFACTURING = 'MANUFACTURING',
  MINING = 'MINING',
  ENERGY = 'ENERGY',
  FISHING_AND_MARITIME = 'FISHING_AND_MARITIME',
  OTHERS = 'OTHERS',
}

export enum BUSINESS_TYPE_ENUM {
  TCP = 'TCP',
  MIPYME = 'MIPYME',
  CNA = 'CNA',
  OTHERS = 'OTHERS',
}

export type IBusinessAccountDocument = {
  originalname?: string;
  size?: number;
  mimetype?: string;
  url: string;
};

export interface IBusinessAccountRequestCompany {
  businessType?: BUSINESS_TYPE_ENUM;
  commercialName: string;
  taxId?: string;
  sector?: BUSINESS_SECTOR_ENUM;
  country?: string;
  taxAddress?: string;
  phone?: string;
}

export interface IBusinessAccountRequestRepresentative {
  name: string;
  email?: string;
  phone?: string;
  role?: string;
  idDocumentNumber?: string;
}

export interface IBusinessAccountRequestDocuments {
  legalRegistration?: IBusinessAccountDocument;
  taxIdDocument?: IBusinessAccountDocument;
  licenses?: IBusinessAccountDocument;
  representativeId?: IBusinessAccountDocument;
}

export interface IBusinessAccountRequest {
  _id: string;
  status: BUSINESS_ACCOUNT_REQUEST_STATUS_ENUM;
  rejectionReason?: string;
  owner?: string;
  company: IBusinessAccountRequestCompany;
  representative: IBusinessAccountRequestRepresentative;
  documents: IBusinessAccountRequestDocuments;
  createdAt: Date;
  updatedAt?: Date;
}
